/**
 * 跨域交互
 * iframe与父页面交互 (实例化时传参 parent)
 * 或
 * 父页面与iframe交互 (实例化时传参 iframe.contentWindow)
 */
export default class {
  constructor(targetWindow) {
    this.contentWindow = targetWindow
    this._messages = {}

    // 监听Target页面的消息
    window.addEventListener('message', e => {
      console.log('\nReceived cross origin stream \nSELF:' + location.href + '\nSOURCE:' + e.origin + '\nDATA:' + e.data + '\n')
      if (e.source !== this.contentWindow) {
        return
      }

      // 解析数据
      let res
      try {
        if (e.data && typeof e.data === 'string') {
          res = JSON.parse(e.data)
        }
      } catch (e) {
      }

      if (res) {
        this._handleMessage(res.action, res.data)
      }
    })
  }

  on(action, handler, self) {
    this._messages[action] = this._messages[action] || []
    this._messages[action].push({
      handler: handler,
      self: self
    })
  }

  off(action, handler) {
    if (!this._messages[action]) {
      return
    } else if (!handler) {
      delete this._messages[action]
    } else {
      for (let i = this._messages[action].length - 1; i >= 0; i--) {
        let obj = this._messages[action][i]
        if (obj.handler === handler) {
          this._messages[action].splice(i, 1)
        }
      }
      if (!this._messages[action].length) {
        delete this._messages[action]
      }
    }
  }

  _handleMessage(action, data) {
    this._messages[action] && this._messages[action].forEach(function (obj) {
      obj.handler.call(obj.self || window, data)
    })
  }

  postMessage(data) {
    this.contentWindow.postMessage(JSON.stringify(data), "*")
  }
}
